var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half is-offset-one-quarter"},[(_vm.recipient)?_c('RecipientForm',{attrs:{"recipient":_vm.recipient},on:{"submit":_vm.updateRecipient}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }